// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"c6e0cddc","321":"ecbb88a3","457":"5a72e7d7","488":"ec7a7115","551":"1a40fecb","707":"20775136","796":"08a877f8","893":"63515839"}[chunkId] + ".chunk.js";
};